<template>
    <b-card
        :title="alertTitle"
        @cancel="$emit('close')"
        @submit="($emit('submit', receiptUrl)&&(receiptUrl=''))"
        :disabled="false"
        :submit-text="{ el: 'OK', en: 'OK', it: 'OK' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
        :loading="loading"
        :submitBtn="false"
    >
        <v-col cols="12" class="pr-2">
            {{ alertText }}
        </v-col>
        <v-text-field
            ref='urlInput'
            v-model="receiptUrl"
            type="text"
            :autofocus="true"
            style="position: relative;z-index: -1;height: 0px;"
        ></v-text-field>
        
    </b-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/pointTitles";

export default {
    name: "ScanAlertDialog",

    mixins: [translations],

    props: {
        alertText: String,
        alertTitle: String
    },

    data() {
        return {
            receiptUrl:''
        };
    },
    computed: {
        ...mapState(["loading", "errorMessage"]),

        lang() {
            return this.$route.params.lang;
        }
    },
    methods: {},
    mounted () {
        this.$clearFocus();
        this.$nextTick(() => {
            // this.$clearFocus();
            // this.$refs.urlInput.focus()
            })
  }
};
</script>
